import { Component, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { DetailsPageTitleService } from '../../shared/services/details-page-title.service';
import { ProductService } from '../../shared/services/product.service';
import { LetDirective } from '@ngrx/component';
import { InternalServerErrorComponent } from '../../components/internal-server-error/internal-server-error.component';
import { DownloadDetailsPageContentComponent } from '../../components/download-details-page-content/download-details-page-content.component';
import { NgTemplateOutlet } from '@angular/common';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
    selector: 'dp-product-details',
    templateUrl: './product-details.component.html',
    imports: [
        LetDirective,
        InternalServerErrorComponent,
        DownloadDetailsPageContentComponent,
        NgTemplateOutlet,
        LoaderComponent,
    ],
})
export class ProductDetailsComponent {
  product$ = this.activatedRoute.params.pipe(
    take(1),
    map(params => params.id),
    switchMap(id => this.productService.getProductById(id)),
    tap(product => {
      this.titleService.setDetailsPageTitle(product.displayTitle);
    }),
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly productService: ProductService,
    private readonly titleService: DetailsPageTitleService,
    @Inject('Window') private readonly window: Window,
  ) {}

  reloadPage(): void {
    this.window.location.reload();
  }
}
